import React from 'react';

import { useAtom } from 'jotai';
import { Button, Loader } from 'semantic-ui-react';

import BaselinePeriod from './Baseline';
import BudgetPeriod from './Budget';
import Constraints from './Constraints';
import { useBudgetPeriod } from './hooks/usePeriods';
import Optimization from './Optimization';
import ProjectionPeriod from './Projection';
import { track } from '../../../../utils/tracking';
import { optimizationAtom, invalidFormAtom } from '../atoms';

const Form = ({
  isConversionKPI,
  trainingDateRange,
  baseline,
  featureNameMap,
  featureStats,
  submitForecast,
  loadingCube,
}) => {
  const { budgetPeriod } = useBudgetPeriod();
  const [optimization] = useAtom(optimizationAtom);
  const [invalidForm] = useAtom(invalidFormAtom);

  const onClickGenerateForecast = () => {
    submitForecast();
    track('mmm.scenario_planner.generate_forecast', { optimization, budgetPeriod });
  };

  return (
    <>
      <ProjectionPeriod />
      <BudgetPeriod />
      <BaselinePeriod {...{ trainingDateRange, baseline }} />
      <Optimization {...{ isConversionKPI, baseline }} />
      <Constraints {...{ isConversionKPI, featureNameMap, featureStats }} />
      <br />
      <Button
        disabled={!optimization || invalidForm || loadingCube}
        onClick={onClickGenerateForecast}
      >
        {loadingCube ? (
          <>
            <Loader active inline size="tiny" />
            <span style={{ marginLeft: '8px' }}>Retrieving baseline data...</span>
          </>
        ) : (
          'Generate Forecast'
        )}
      </Button>
      <br />
      <br />
    </>
  );
};

export default Form;
